import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { BookOpen, Calculator, FileStack, Settings as SettingsIcon, LayoutDashboard } from "lucide-react";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/calculator", label: "Calculator", icon: Calculator, testid: "nav-calculator" },
  { to: "/quotes", label: "Quotes", icon: FileStack, testid: "nav-quotes" },
  { to: "/settings", label: "Pricing", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Layout() {
  const location = useLocation();
  const isPrint = location.pathname.startsWith("/quotes/") && location.pathname.split("/").length === 3;
  return (
    <div className="min-h-screen flex flex-col bg-white text-[#050505]">
      <header
        className="no-print sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-[#050505]"
        data-testid="site-header"
      >
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-8 lg:px-12 flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
            <img src="/logo.png" alt="2RA-press" className="h-10 w-auto" />
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `px-4 h-10 flex items-center gap-2 text-[12px] uppercase tracking-[0.18em] font-bold transition-colors border ${
                    isActive
                      ? "bg-[#050505] text-white border-[#050505]"
                      : "border-transparent text-[#050505] hover:border-[#050505]"
                  }`
                }
              >
                <item.icon className="w-4 h-4" strokeWidth={1.5} />
                {item.label}
              </NavLink>
            ))}
          </nav>

          <Link
            to="/calculator"
            data-testid="header-new-quote-btn"
            className="btn-primary hidden md:inline-flex"
          >
            New Quote
          </Link>
        </div>
        {/* Mobile nav */}
        <div className="md:hidden border-t border-[#e5e5e5]">
          <div className="flex">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`m-${item.testid}`}
                className={({ isActive }) =>
                  `flex-1 h-12 flex items-center justify-center gap-1 text-[11px] uppercase tracking-[0.16em] font-bold ${
                    isActive ? "bg-[#050505] text-white" : "text-[#050505]"
                  }`
                }
              >
                <item.icon className="w-3.5 h-3.5" strokeWidth={1.5} />
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      </header>

      <main className={`flex-1 ${isPrint ? "" : ""}`}>
        <Outlet />
      </main>

      <footer className="no-print border-t border-[#050505] mt-12">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.2em] text-[#525252]">
          <div>© 2RA-press — Book Quote Studio</div>
          <div className="font-mono">v1.0 · USD pricing</div>
        </div>
      </footer>
    </div>
  );
}
